<template>
  <div
    :class="[
      'element-texts flex flex-col justify-start',
      {
        'pos-left': props.textPosition === 'left',
        'pos-center': props.textPosition === 'center',
        'pos-right': props.textPosition === 'right',
      },
    ]"
  >
    <template v-for="(element, idx) in bloks" :key="element._uid">
      <SbRichtextDisplay
        v-if="element.component === 'RichtextDisplay'"
        :blok="element"
        :class="classesHeaders"
      />
      <SbRichtextHeadline
        v-else-if="element.component === 'RichtextHeadline'"
        :blok="element"
        :class="classesHeaders"
      />
      <SbRichtextText
        v-else-if="element.component === 'RichtextText'"
        :blok="element"
        :class="classes"
      />
      <SbRichtextQuote
        v-else-if="element.component === 'RichtextQuote'"
        :blok="element"
        :class="classes"
      />
      <SbRichtextGraphic
        v-else-if="element.component === 'RichtextGraphic'"
        :blok="element"
        :class="classes"
      />
      <SbRichtextSocialMediaButtons
        v-else-if="element.component === 'RichtextSocialMediaButtons'"
        :blok="element"
        :class="classes"
      />
      <SbRichtextButtons
        v-else-if="element.component === 'RichtextButtons'"
        :blok="element"
        :class="[
          ...classes,
          {
            'flex-1 flex flex-col !justify-end':
              idx === bloks.length - 1 && props.buttonAlignment === 'bottom',
          },
        ]"
        :size="buttonSize"
        :variant="buttonVariant"
      />
    </template>
  </div>
</template>

<script setup lang="ts">
import {
  RichtextDisplayStoryblok,
  RichtextHeadlineStoryblok,
  RichtextButtonsStoryblok,
  RichtextQuoteStoryblok,
  RichtextTextStoryblok,
  RichtextGraphicStoryblok,
  RichtextSocialMediaButtonsStoryblok,
} from '@/types';
import { PropsButtonBase } from '@/components/atoms/AButtonBase.vue';

type Props = {
  bloks: (
    | RichtextDisplayStoryblok
    | RichtextHeadlineStoryblok
    | RichtextTextStoryblok
    | RichtextQuoteStoryblok
    | RichtextButtonsStoryblok
    | RichtextGraphicStoryblok
    | RichtextSocialMediaButtonsStoryblok
  )[];
  textPosition?: 'left' | 'center' | 'right';
  gap?: 'xs' | 'sm' | 'md';
  buttonSize?: PropsButtonBase['size'];
  buttonVariant?: PropsButtonBase['variant'];
  buttonAlignment?: 'top' | 'bottom';
};
const props = withDefaults(defineProps<Props>(), {
  textPosition: 'left',
  gap: 'md',
  buttonSize: 'md',
});

const classes = computed(() => [
  'text-max-w',
  { 'not-last:clamp-mb-3-4': props.gap === 'xs' },
  { 'not-last:clamp-mb-8-12': props.gap === 'md' },
]);

const classesHeaders = computed(() => [
  { 'not-last:clamp-mb-2-5': props.gap === 'xs' },
  { 'not-last:clamp-mb-3-4': props.gap === 'sm' },
  { 'not-last:clamp-mb-4-6': props.gap === 'md' },
]);
</script>

<style lang="scss" scoped>
.element-texts {
  &.pos-left {
    @apply mr-auto;
    > * {
    }
  }
  &.pos-center {
    @apply mx-auto text-center;
    > * {
      @apply mx-auto;
      @apply justify-center items-center;
    }
  }
  &.pos-right {
    @apply mx-auto mr-0 mt-auto text-right;
    > * {
      @apply mx-auto mr-0 mt-auto;
      @apply justify-end;
    }
  }
}
</style>
